import {useDispatch, useSelector} from "react-redux";
import {Dropdown} from "react-bootstrap";
import React, {useEffect, useState} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {excelFileUploader} from "../../../../helpers/excel-uploader";
import {faFileExcel, faSpinner} from "@fortawesome/free-solid-svg-icons";
import {selectLang, Translate} from "../../../../app/store/reducers/main/mainReducer";
import {TYPE_INVOICES, TYPE_INVOICES_WITH_ITEMS} from "../../../../enum/ExcelTemplateTypes";
import {selectOrganizationTemplates} from "../../../../app/store/reducers/excel/excelReducer";
import {
    selectFilterOptions,
    uploadInvoicesToExcelAsync,
    uploadInvoicesWithItemsToExcelAsync,
    uploadSelectedInvoicesToExcelAsync, uploadSelectedInvoicesWithItemsToExcelAsync
} from "../../../../app/store/reducers/invoice/invoiceReducer";
import checkPermission from "../../../../enum/Permission/CheckPermission";
import {PermissionEdiInvoiceDownloadExcel} from "../../../../enum/Permission/EdiPermission";
import toastPermission from "../../../../enum/Permission/ToastPermission";
import {toast} from "react-toastify";

const UploadInvoiceListToExcel = ({rowValues,selectable, ...props}) => {
    const dispatch = useDispatch()
    const [invoicesWithItemsTypeTemplates, setInvoicesWithItemsTypeTemplates] = useState([]);
    const [invoicesTypeTemplates, setInvoicesTypeTemplates] = useState([]);
    const organizationTemplates = useSelector(selectOrganizationTemplates);

    useEffect(() => {
        const invoicesTemplates = organizationTemplates.filter(template => template.type === TYPE_INVOICES) || [];
        const invoicesWithItemsTemplates = organizationTemplates.filter(template => template.type === TYPE_INVOICES_WITH_ITEMS) || [];

        setInvoicesTypeTemplates(invoicesTemplates);
        setInvoicesWithItemsTypeTemplates(invoicesWithItemsTemplates);
    }, [organizationTemplates])

    const [loading, setLoading] = useState(false);
    const filter = useSelector(selectFilterOptions);
    const lang = useSelector(selectLang);
    const t = Translate;

    const uploadExcel = (uri) => {
        setLoading(true);

        if (rowValues?.length > 0) {
            for (let i = 0; i < rowValues.length; i++) {
                const row = rowValues[i];

                if (row.isSelected) {

                    uploadSelectedInvoicesToExcelAsync(row.original.id)
                        .then(loadedContent => {
                            excelFileUploader({
                                content: loadedContent,
                                fileName: t(lang, 'edi.invoices.excel_upload.file_name'),
                            });
                        })
                        .catch(error => toast.error(t(lang, "common.toast.error")))
                        .finally(() => setLoading(false))
                }
            }


        } else {
            uploadInvoicesToExcelAsync({...filter, uri: uri})
                .then(loadedContent => {
                    excelFileUploader({
                        content: loadedContent,
                        fileName: t(lang, 'edi.invoices.excel_upload.file_name')
                    });
                })
                .catch(error => console.log(error))
                .finally(() => setLoading(false))
        }
    }

    const uploadWithItems = (uri) => {
        setLoading(true);

        if (rowValues?.length > 0) {
            for (let i = 0; i < rowValues.length; i++) {
                const row = rowValues[i];

                if (row.isSelected) {
                    uploadSelectedInvoicesWithItemsToExcelAsync([row.original.id])
                        .then(loadedContent => {
                            excelFileUploader({
                                content: loadedContent,
                                fileName: t(lang, 'edi.invoices_with_items.excel_upload.file_name'),
                            });
                        })
                        .catch(error => toast.error(t(lang, "common.toast.error")))
                        .finally(() => setLoading(false))
                }
            }

        } else {
            uploadInvoicesWithItemsToExcelAsync({...filter, uri: uri})
                .then(loadedContent => {
                    excelFileUploader({
                        content: loadedContent,
                        fileName: t(lang, 'edi.invoices_with_items.excel_upload.file_name')
                    });
                })
                .catch(error => console.log(error))
                .finally(() => setLoading(false))
        }


    }
    const uploadInvoices = (uri) => {
        if(dispatch(checkPermission(PermissionEdiInvoiceDownloadExcel))) uploadExcel(uri)
        else dispatch(toastPermission())
    }

    const uploadInvoicesWithItems = (uri) => {
        if(dispatch(checkPermission(PermissionEdiInvoiceDownloadExcel))) uploadWithItems(uri)
        else dispatch(toastPermission())
    }

    return (
        <>
            <Dropdown {...props}>
                <Dropdown.Toggle bsPrefix="toggle" variant="falcon-default" size="sm" disabled={loading}>
                    {loading
                        ?
                        <FontAwesomeIcon className="me-1" pulse={true} icon={faSpinner}/>
                        :
                        <FontAwesomeIcon className="me-1" icon={faFileExcel}/>
                    }
                    <span className="d-none d-sm-inline-block">
                        {t(lang, 'edi.invoice.datatable.header.navigation.dropdown.export_to_excel')}
                    </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className='py-2'>
                    <>
                        <Dropdown.Header className="text-black">{t(lang, 'edi.invoice.datatable.header.navigation.dropdown.item.export_invoices_to_excel')}</Dropdown.Header>
                        {invoicesTypeTemplates.map((template, index) => (
                            <Dropdown.Item className="ps-4" key={index} onClick={() => uploadInvoices(template.uri)}>{t(lang, `common.excel.template.name.${template.name}`)}</Dropdown.Item>
                        ))}
                    </>

                    <>
                        <Dropdown.Header className="text-black">{t(lang, 'edi.invoice.datatable.header.navigation.dropdown.item.export_invoices_with_items_to_excel')}</Dropdown.Header>
                        {invoicesWithItemsTypeTemplates.map((template, index) => (
                            <Dropdown.Item className="ps-4" key={index} onClick={() => uploadInvoicesWithItems(template.uri)}>{t(lang, `common.excel.template.name.${template.name}`)}</Dropdown.Item>
                        ))}
                    </>
                </Dropdown.Menu>
            </Dropdown>
        </>
    );
};

export default UploadInvoiceListToExcel;
